module.exports = __webpack_public_path__ + "img/西北大学.4f70ed0c.png";